export default "/images/vendor/@coreui/icons/svg/flag/cif-ls.svg?231cb8a142b19fef2b6a81c9d608fb6e";